import { render, staticRenderFns } from "./ModalProductTypeEdit.vue?vue&type=template&id=40f2d512&scoped=true"
import script from "./ModalProductTypeEdit.vue?vue&type=script&lang=js"
export * from "./ModalProductTypeEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalProductTypeEdit.vue?vue&type=style&index=0&id=40f2d512&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f2d512",
  null
  
)

export default component.exports